import { createFileRoute } from '@tanstack/react-router'
import { BlockCallerIdsPage } from '@/features/admin/block-caller-ids'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/block-caller-ids/')({
  component: BlockCallerIdsPage,
  beforeLoad: requireRole(['admin']),
})
